import { bigFeedItems } from '@/mocks/homeData';

export default function BigFeedGrid() {
  return (
    <section id="feed" className="w-full border-t border-background-200 bg-background-100 py-10 md:py-14">
      <div className="mx-auto w-full max-w-[1360px] px-4 md:px-6">
        <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="text-xs font-bold uppercase tracking-[0.2em] text-secondary-600">
              Big Picture Feed
            </span>
            <h2 className="mt-2 font-heading text-xl font-black tracking-tight text-foreground-950 md:text-3xl">
              大图卡片流 · 封面直接说话
            </h2>
            <p className="mt-2 max-w-2xl text-sm text-foreground-600">
              黑料六点把今天热度靠前的条目做成大图卡，先看图，再看摘要，点进评论区继续挖。
            </p>
          </div>
          <div className="flex flex-wrap items-center gap-2">
            {['全部', '综艺', '剧集', '电竞', '时尚', '商务'].map((tab, index) => (
              <button
                key={tab}
                type="button"
                className={`cursor-pointer whitespace-nowrap rounded-full px-3.5 py-1.5 text-xs font-medium transition-colors ${
                  index === 0
                    ? 'bg-foreground-950 text-background-50'
                    : 'border border-background-300 bg-background-50 text-foreground-700 hover:border-primary-300 hover:text-primary-600'
                }`}
              >
                {tab}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {bigFeedItems.map((item, index) => (
            <article
              key={item.id}
              className={`group flex cursor-pointer flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300 ${
                index === 0 ? 'sm:col-span-2 lg:col-span-2' : ''
              }`}
            >
              <div
                className={`relative w-full overflow-hidden bg-background-200 ${
                  index === 0 ? 'h-[220px] md:h-[320px]' : 'h-[190px] md:h-[200px]'
                }`}
              >
                <img
                  src={item.cover}
                  alt={`黑料六点每日定时 ${item.tag}：${item.title}`}
                  title={`黑料六点 ${item.tag} 大图卡片 ${item.title}`}
                  className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 flex h-6 items-center rounded-md bg-foreground-950/70 px-2.5 text-xs font-semibold text-background-50 backdrop-blur">
                  {item.tag}
                </span>
                <span className="absolute right-3 top-3 flex h-6 items-center gap-1 rounded-md bg-background-50/90 px-2 text-[11px] font-medium text-foreground-800 backdrop-blur">
                  <i className="ri-time-line" />
                  {item.time}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-4">
                <h3
                  className={`font-heading font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600 ${
                    index === 0 ? 'text-lg md:text-xl' : 'text-base'
                  }`}
                >
                  {item.title}
                </h3>
                <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">
                  {item.excerpt}
                </p>
                <div className="mt-4 flex items-center gap-4 border-t border-background-100 pt-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1.5">
                    <i className="ri-chat-3-line text-sm" />
                    {item.comments}
                  </span>
                  <span className="flex items-center gap-1.5">
                    <i className="ri-fire-line text-sm text-primary-500" />
                    {item.heat}
                  </span>
                  <span className="ml-auto flex h-7 w-7 items-center justify-center rounded-full bg-background-100 text-foreground-700 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                    <i className="ri-arrow-right-up-line text-sm" />
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}